import {HttpErrorResponse,HttpHeaders,HttpResponse} from '@angular/common/http';
import {Component,OnDestroy,OnInit} from '@angular/core';
import {ActivatedRoute,ParamMap,Router} from '@angular/router';
import {JhiAlertService,JhiEventManager,JhiParseLinks} from 'ng-jhipster';
import {Subscription} from 'rxjs';

import {Principal} from 'src/app/core';
import {ISanctionedGroupMySuffix} from 'src/app/shared/model/sanctioned-group-my-suffix.model';

import {ITEMS_PER_PAGE} from 'src/app/shared/constants/pagination.constants';
import {LanguageChangeService} from 'src/app/shared/services/language-change.service';
import {RoleUtil} from 'src/app/shared/util/role-util';
import {SanctionedGroupMySuffixService} from './sanctioned-group-my-suffix.service';
import { CommonUtils } from 'src/app/shared/util/common-utils';
declare let $:any;
import { debounce } from "lodash";
@Component({
    selector: 'jhi-sanctioned-group-my-suffix',
    templateUrl: './sanctioned-group-my-suffix.component.html'
})
export class SanctionedGroupMySuffixComponent implements OnInit, OnDestroy {
    currentAccount: any;
    sanctionedGroups: ISanctionedGroupMySuffix[];
    error: any;
    success: any;
    eventSubscriber: Subscription;
    routeData: any;
    links: any;
    totalItems: any;
    queryCount: any;
    itemsPerPage: any;
    page: any;
    predicate: any;
    previousPage: any;
    reverse: any;
    searchText: string;
    flag: boolean;
    isShowPastHistory: boolean;
    isShowFutureHistory: boolean;
    sanctionGroupId: number;
    modalTitle: string = 'Confirm operation';
    modalContent: string;
    status: string = '';
    showActiveModel: boolean=false;
    
    public readonly RoleUtil = RoleUtil;

    constructor(
        private sanctionedGroupService: SanctionedGroupMySuffixService,
        private parseLinks: JhiParseLinks,
        private jhiAlertService: JhiAlertService,
        public principal: Principal,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private eventManager: JhiEventManager,
        private languageChangeService:LanguageChangeService,
    ) {
        this.itemsPerPage = ITEMS_PER_PAGE;
        this.routeData = this.activatedRoute.data.subscribe(data => {
            this.page = data.pagingParams.page;
            this.previousPage = data.pagingParams.page;
            this.reverse = data.pagingParams.ascending;
            this.predicate = data.pagingParams.predicate;
            // if(this.itemsPerPage == 25 && this.page >1){
            //     this.page =1;
            //     this.previousPage = 1;
            // }
        });
                this.languageChangeService.refreshLanguage();
        this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            if (paramMap.get('size')) {
                this.itemsPerPage = paramMap.get('size')
            }
            const refresh = paramMap.get('refresh');
            if (refresh) {
                this.languageChangeService.refreshLanguage();
                window.history.back()
            }
    });
    }

    loadAll() {
        this.searchText='';
        this.sanctionedGroupService
            .query({
                page: this.page - 1,
                size: this.itemsPerPage,
                sort: this.sort()
            })
            .subscribe(
                (res: HttpResponse<ISanctionedGroupMySuffix[]>) => this.paginateSanctionedGroups(res.body, res.headers),
                (res: HttpErrorResponse) => this.onError(res.message)
            );
    }

    loadPage(page: number) {
        if (page !== this.previousPage) {
            this.previousPage = page;
            this.transition();
        }
    }

    transition() {
        if (this.searchText) {
            this.searchItems();
            this.flag = true;
        } else {
            this.router.navigate(['/data-management/sanctioned-group'], {
                queryParams: {
                    page: this.page,
                    size: this.itemsPerPage,
                    sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
                }
            });
            this.loadAll();
        }
    }

    clear() {
        this.page = 0;
        this.router.navigate([
            '/data-management/sanctioned-group',
            {
                page: this.page,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }
        ]);
        this.loadAll();
    }
    addZeroPadding: boolean;
    ngOnInit() {
        this.principal.setTitle("Sanctioned Countries");
        this.isShowPastHistory = this.principal.isShowPastHistory;
        this.isShowFutureHistory = this.principal.isShowFutureHistory;
        this.loadAll();
        this.principal.identity().then(account => {
            this.currentAccount = account;
            console.log(this.currentAccount, "this.currentAccount");
            if (this.currentAccount.userRole != "BROKER" && this.currentAccount.userRole != "BROKER_STAFF") {
                this.addZeroPadding = true;
            } else {
                this.addZeroPadding = false;
            }

        });
        this.registerChangeInSanctionedGroups();
    }

    ngOnDestroy() {
        if (this.eventSubscriber) 
        this.eventManager.destroy(this.eventSubscriber);
    }

    trackId(index: number, item: ISanctionedGroupMySuffix) {
        return item.id;
    }

    registerChangeInSanctionedGroups() {
        this.eventSubscriber = this.eventManager.subscribe('sanctionedGroupListModification', response => this.loadAll());
    }

    sort() {
        const result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
        if (this.predicate !== 'id') {
            result.push('id');
        }
        return result;
    }

    private paginateSanctionedGroups(data: ISanctionedGroupMySuffix[], headers: HttpHeaders) {
        this.links = this.parseLinks.parse(headers.get('link'));
        this.totalItems = parseInt(headers.get('X-Total-Count'), 10);
        this.queryCount = this.totalItems;
        this.sanctionedGroups = data;
    }

    private onError(errorMessage: string) {
        this.jhiAlertService.error(errorMessage, null, null);
    }
    searchItems() {
        // if (this.searchText) {
        //     let pNo = 0;
        //      let size = this.itemsPerPage;
        //     if (this.flag == true) {
        //         pNo = this.page - 1;
        //         size = this.itemsPerPage;
        //         this.flag = false;
        //     }
        //     this.principal
        //         .searchQuery(this.searchText, 'sanctioned-groups/search', {
        //             page: pNo,
        //             size: size,
        //             sort: this.sort()
        //         })
        //         .subscribe(
        //             (res: HttpResponse<ISanctionedGroupMySuffix[]>) => this.paginateSanctionedGroups(res.body, res.headers),
        //             (res: HttpErrorResponse) => this.onError(res.message)
        //         );
        // } else {
        //     this.loadAll();
        // }
        this.searchUsingDebounce();
    }

    // history
    parentHistoryToggle = false;
    historyData = [];
    historyTitle: string;
    historyType: string;
    historyId: number;
    parentFutureHistoryToggle = false;
    receiveToggleEvent($event) {
        this.parentHistoryToggle = $event;
        this.parentFutureHistoryToggle = $event;
    }

    viewFutureHistory(Obj) {
        this.parentFutureHistoryToggle = true;
        this.historyTitle = 'Sanctioned Groups (' + Obj.name + ') Future Records';
        this.historyType = "SANCTION_GROUPS_AUDIT";
        this.historyId = Obj.id;
        $('.dropdown.show .dropdown-toggle').dropdown('toggle');
    }

    viewHistory(Obj) {
        this.parentHistoryToggle = true;
        this.historyTitle = 'Sanctioned Groups (' + Obj.name + ') History';
        this.historyType = "SANCTION_GROUPS_AUDIT";
        this.historyId = Obj.id;
        $('.dropdown.show .dropdown-toggle').dropdown('toggle');
    } 
    onChange(value){
        this.page = 0;
        this.itemsPerPage=value
        this.loadAll();
    }
    hideFutureHistorySidebar() {
        if (document.getElementById("future-history-window")) {
            this.parentHistoryToggle = false;
            this.parentFutureHistoryToggle = false;
        }
    }

    openActivateModal(status, sanctionGroupId) {
        this.showActiveModel = true;
        this.sanctionGroupId = sanctionGroupId;
        if (status == 'ACTIVATE') {
            this.modalContent = 'Are you sure you want to activate this Sanctioned Group?'
            this.status = 'ACTIVE';
        } else {
            this.modalContent = 'Are you sure you want to In-activate this Sanctioned Group?'
            this.status = 'IN_ACTIVE'
        }
    }

    changeSanctionedGroupStatus() {
        if (this.sanctionGroupId) {
            this.sanctionedGroupService.delete(this.sanctionGroupId).subscribe(response => {
                if (this.status == 'ACTIVE') {
                    this.jhiAlertService.success('The Sanctioned Group has been activated successfully')
                } else {
                    this.jhiAlertService.success('The Sanctioned Group has been de-activated successfully')
                }
                this.loadAll();
            });
        }
    }

    closeActiveModels(e: boolean) {
        this.showActiveModel = e;
    }

    searchUsingDebounce = debounce(params => {
        if (this.searchText) {
            let pNo = 0;
            let size = this.itemsPerPage;
            if (CommonUtils.isNotNil(this.flag) && CommonUtils.isTrue(this.flag)) {
                pNo = this.page - 1;
                size = this.itemsPerPage;
                this.flag = false;
            } else {
                this.previousPage = this.page = 1;
            }
            this.principal
                .searchQuery(this.searchText, 'sanctioned-groups/search', {
                    page: pNo,
                    size: size,
                    sort: this.sort()
                })
                .subscribe(
                    (res: HttpResponse<ISanctionedGroupMySuffix[]>) => this.paginateSanctionedGroups(res.body, res.headers),
                    (res: HttpErrorResponse) => this.onError(res.message)
                );
        } else {
            this.loadAll();
        }
    }, 700);
}
